module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image20.08d209b9.jpg";